import * as R from 'ramda'

const logicOptions = [
    {
        label: 'All',
        value: 'AND',
        show: ['DT'],
    },
    {
        label: 'One of',
        value: 'OR',
    },
]
class Rule {
    ruleType = 'rule'

    constructor({
        id,
        logic = 'OR',
        options = [],
        label = '',
        questionTypeCode,
    }) {
        this.id = id
        this.logic = logic
        this.options = options
        this.label = label
        this.questionTypeCode = questionTypeCode
    }

    static clone(rule) {
        return new Rule({
            id: rule.id,
            logic: rule.logic,
            options: rule.options.slice(),
            label: rule.label,
            questionTypeCode: rule.questionTypeCode,
        })
    }

    removeOption(index) {
        this.options.slice(index, 2)
    }

    static getOptions(questionType) {
        return logicOptions.filter(({ show }) => (
            R.isNil(show) || show.includes(questionType)
        ))
    }

    toJSON() {
        return {
            ruleType: this.ruleType,
            id: this.id,
            logic: this.logic,
            options: this.options,
        }
    }
}

export default Rule
